import { useState, useEffect, useCallback } from 'react';
import { useSound } from './useSound';

export const useTimer = (initialTime = 1, onTimeEnd = () => {}) => {
    const [time, setTime] = useState(initialTime * 60); // Konwersja na sekundy
    const [isRunning, setIsRunning] = useState(false);
    const [customTime, setCustomTime] = useState(initialTime);

    const { playTick, playAlarm, playCountdown, playWarning } = useSound();

    // Reset timera do wartości customTime
    const resetTimer = useCallback(() => {
        setIsRunning(false);
        // Sprawdzenie czy customTime jest liczbą i czy jest większa od 0
        const timeInSeconds = (customTime && !isNaN(customTime)) ? customTime * 60 : 1 * 60;
        setTime(timeInSeconds);
    }, [customTime]);

    // Zmiana czasu rundy - zmodyfikowana funkcja
    const handleTimeChange = useCallback((minutes) => {
        // Obsługa pustego pola
        if (minutes === '') {
            setCustomTime('');
            return;
        }

        const newTime = parseInt(minutes, 10);
        if (!isNaN(newTime) && newTime > 0) {
            setCustomTime(newTime);
            setTime(newTime * 60);
        }
    }, []);

    // Logika timera
    useEffect(() => {
        let interval = null;

        if (isRunning && time > 0) {
            interval = setInterval(() => {
                setTime(prevTime => {
                    const newTime = prevTime - 1;

                    // Dźwięk ostrzegawczy przy 10 sekundach
                    if (newTime === 10) {
                        playWarning();
                    }
                    // Odliczanie ostatnich 5 sekund
                    else if (newTime > 0 && newTime <= 5) {
                        playCountdown();
                    }
                    // Dźwięk końca czasu
                    else if (newTime === 0) {
                        playAlarm();
                        onTimeEnd();
                    }
                    // Odtwarzanie dźwięku tykania co 10 sekund (tylko gdy nie jesteśmy w fazie odliczania)
                    else if (newTime > 10 && newTime % 10 === 0) {
                        playTick();
                    }

                    return newTime;
                });
            }, 1000);
        } else if (time === 0) {
            setIsRunning(false);
        }

        return () => clearInterval(interval);
    }, [isRunning, time, playTick, playAlarm, playCountdown, playWarning, onTimeEnd]);

    // Funkcje sterujące timerem
    const startTimer = () => {
        // Sprawdzenie przed uruchomieniem, czy mamy ustawiony czas
        if (!customTime || isNaN(customTime)) {
            // Ustaw domyślny czas 1 minutę jeśli pole jest puste
            setCustomTime(1);
            setTime(1 * 60);
        }
        setIsRunning(true);
    };

    const pauseTimer = () => setIsRunning(false);

    return {
        time,
        isRunning,
        customTime,
        startTimer,
        pauseTimer,
        resetTimer,
        handleTimeChange
    };
};